import {Component} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {PermissionService} from '../../../core/permission.service';
import {FeatureToggleService} from '../../feature-toggle/feature-toggle.service';
import {FeatureToggle} from '../../feature-toggle/feature-toggle';
import {combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {REGION_PERMISSIONS} from '../../../region-management/region.permissions';
import {MIN_MAX_CONFIG_PERMISSIONS} from '../../../config-management/min-max-config/min-max-config.permissions';
import {ENTERPRISES_PERMISSIONS} from '../../../enterprises/enteprises.permissions';
import {USER_MANAGEMENT_PERMISSIONS} from '../../../user-management/user-management.permissions';
import {ASSET_ADMINISTRATION_PERMISSIONS} from '../../../asset-administration/asset-administration.permissions';
import {REPORT_PERMISSIONS} from '../../../reports/reports.permissions';

@Component({
  selector: 'app-lms-nav-bar',
  templateUrl: './lms-nav-bar.component.html',
  styleUrls: ['./lms-nav-bar.component.scss'],
})
export class LmsNavBarComponent {
  routeFlag = true;
  canViewReports$ = combineLatest([
    this.permissionService.hasUserPermission$(REPORT_PERMISSIONS.VIEW_ALARMS),
    this.permissionService.hasUserPermission$(REPORT_PERMISSIONS.VIEW_INSTRUMENTS),
    this.permissionService.hasUserPermission$(REPORT_PERMISSIONS.VIEW_DATA_ITEMS)
  ]).pipe(
    map(([canViewAlarms, canViewInstruments, canViewDataItems]) => canViewAlarms || canViewInstruments || canViewDataItems)
  );
  canViewAssetManagement$ = this.permissionService.hasUserPermission$(ASSET_ADMINISTRATION_PERMISSIONS.VIEW);
  canViewUserManagement$ = this.permissionService.hasUserPermission$(USER_MANAGEMENT_PERMISSIONS.VIEW);
  canViewRegionManagement$ = this.permissionService.hasUserPermission$(REGION_PERMISSIONS.VIEW);
  isSubRegionManagementEnabled$ = this.featureToggleService.isFeatureEnabled$(FeatureToggle.SUB_REGION_MANAGEMENT);
  private readonly isCarcEnabled$ = this.featureToggleService.isFeatureEnabled$(FeatureToggle.CARC);
  private readonly isMinMaxConfigurationEnabled$ = this.permissionService.hasUserPermission$(MIN_MAX_CONFIG_PERMISSIONS.VIEW);
  readonly isConfigTabEnabled$ = combineLatest([
    this.isMinMaxConfigurationEnabled$,
    this.isCarcEnabled$
  ]).pipe(
    map(([isConfigEnabled, isCarcEnabled]) => isConfigEnabled && isCarcEnabled)
  );
  private readonly isEnterpriseManagementEnabled$ = this.permissionService.hasUserPermission$(ENTERPRISES_PERMISSIONS.VIEW);
  readonly isEnterprisesTabEnabled$ = combineLatest([
    this.isEnterpriseManagementEnabled$,
    this.isCarcEnabled$,
  ]).pipe(
    map(([isEnterpriseEnabled, isCarcEnabled]) => isEnterpriseEnabled && isCarcEnabled)
  );

  constructor(
    private readonly route: Router,
    private readonly permissionService: PermissionService,
    private readonly featureToggleService: FeatureToggleService,
  ) {
    this.route.events.subscribe((r) => {
      if (r instanceof NavigationEnd) {
        this.loadNavBar(r.url);
      }
    });
  }

  loadNavBar(route): void {
    const routeUrl = route.split('?')[0];
    this.routeFlag = !(routeUrl.endsWith('alarm-history') ||
      routeUrl.endsWith('device-data-history') ||
      routeUrl.endsWith('rule') ||
      routeUrl.endsWith('create-new-user') ||
      routeUrl.endsWith('view-edit-user') ||
      routeUrl.endsWith('create-new-role') ||
      routeUrl.endsWith('view-role'));
  }
}
